import { render, staticRenderFns } from "./AddUserPage.vue?vue&type=template&id=5f310d1d&scoped=true&"
import script from "./AddUserPage.vue?vue&type=script&lang=js&"
export * from "./AddUserPage.vue?vue&type=script&lang=js&"
import style0 from "./AddUserPage.vue?vue&type=style&index=0&id=5f310d1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f310d1d",
  null
  
)

export default component.exports